<template>
  <div class="page_search_area permission">
    <el-form :inline="true">
      <el-form-item label="创建日期：" class="search_item_area">
        <el-date-picker
          v-model="searchData.dateRange"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          start-placeholder="年/月/日"
          end-placeholder="年/月/日"
          :picker-options="datePickerOptions"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="岗位名称：" class="search_item_area">
        <el-input
          v-model.trim="searchData.name"
          placeholder="请输入岗位名称"
          maxlength="30"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="备注：" class="search_item_area">
        <el-input
          v-model.trim="searchData.remarks"
          placeholder="请输入备注"
          maxlength="30"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item class="search_item_area">
        <el-button class="search_btn" type="primary" @click="btnSearchClick"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import mixins from "./Mixins";
export default {
  mixins: [mixins],
  data() {
    return {
      dateRange: "",
      datePickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("2021-01-01")
          );
        },
      },
    };
  },
  computed: {
    searchData() {
      return this.Permission.searchData;
    },
    pageData() {
      return this.Permission.pageData;
    },
  },
  created() {
    this.getTableList_A();
  },
  methods: {
    btnSearchClick() {
      this.SETOPTIONS({
        pageData: {
          page: 1,
          size: this.pageData.size,
          total: 0,
        },
      });
      this.getTableList_A();
    },
  },
};
</script>

<style lang="stylus" scoped>
.page_search_area.permission {
  height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PartI/PermissionPackage/components/pmsSearch.vue